/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AccountTreeOutlined,
    BadgeOutlined,
    CheckroomOutlined,
    DashboardOutlined,
    SettingsOutlined,
    ShoppingCartOutlined,
    PeopleOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Colecciones from "./Secciones/Seccion_Colecciones";
import Seccion_Productos from "./Secciones/Seccion_Productos";
import Seccion_Fotos from "./Secciones/Seccion_Fotos";
import Seccion_Configuraciones from "./Secciones/Seccion_Configuraciones";
import Seccion_Pedidos from "./Secciones/Seccion_Pedidos";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_SubCategorias from "./Secciones/Seccion_SubCategorias";
import Seccion_Suscriptores from "./Secciones/Seccion_Suscriptores";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

        </Grid>
    )

}
export default Dashboard

const secciones = [


    {
        nombre: 'Pedidos',
        icono: ShoppingCartOutlined,
        camino: '/Pedidos',
        categoria: 'Tienda',
        Componente: <Seccion_Pedidos/>
    },
    {
        nombre: 'Colecciones',
        icono: DashboardOutlined,
        camino: '/Colecciones',
        categoria: 'Tienda',
        Componente: <Seccion_Colecciones/>
    },
    {
        nombre: 'Prendas',
        icono: CheckroomOutlined,
        camino: '/Prendas',
        categoria: 'Tienda',
        Componente: <Seccion_Productos/>
    },
    {
        nombre: 'Fotos',
        icono: DashboardOutlined,
        camino: '/Fotos',
        categoria: 'Tienda',
        Componente: <Seccion_Fotos/>
    },
    {
        nombre: 'Suscriptores',
        icono: PeopleOutlined,
        camino: '/Suscriptores',
        categoria: 'Tienda',
        Componente: <Seccion_Suscriptores/>
    },
    {
        nombre: 'SubCategorias',
        icono: AccountTreeOutlined,
        camino: '/SubCategorias',
        categoria: 'Configuraciones',
        Componente: <Seccion_SubCategorias/>
    },
    {
        nombre: 'Generales',
        icono: SettingsOutlined,
        camino: '/Generales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Configuraciones/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: true,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}